export const fontWeight = {
  regular: 400,
  bold: 700,
  black: 900,
};
